/**
 * Team Members & Invitations - Team and user management
 */

/** Organization role types */
export type OrgRole = 'owner' | 'admin' | 'member' | 'viewer'

/** Organization role display labels */
export const ORG_ROLE_LABELS: Record<OrgRole, string> = {
  owner: 'Owner',
  admin: 'Admin',
  member: 'Member',
  viewer: 'Viewer',
}

/** Organization role descriptions */
export const ORG_ROLE_DESCRIPTIONS: Record<OrgRole, string> = {
  owner: 'Full organization control',
  admin: 'Manage team and settings',
  member: 'Access all resources',
  viewer: 'View-only access',
}

/** All organization roles for select dropdowns */
export const ORG_ROLES: OrgRole[] = [
  'owner',
  'admin',
  'member',
  'viewer',
]

/** Roles that can be assigned (excludes owner which cannot be changed) */
export const ASSIGNABLE_ROLES: OrgRole[] = [
  'admin',
  'member',
  'viewer',
]

/** Team member from RPC response */
export interface TeamMember {
  user_id: string
  role: OrgRole
  is_primary_owner: boolean
  email: string
  display_name: string | null
  created_at: string
}

/** Invitation from organization_invitations table */
export interface TeamInvitation {
  id: string
  organization_id: string
  email: string
  role: OrgRole
  created_at: string
  created_by: string | null
}

/** Form data for inviting a member (legacy) */
export interface InviteMemberFormData {
  email: string
  role: OrgRole
}

/** Form data for updating member role */
export interface UpdateMemberRoleFormData {
  role: OrgRole
}

/** Location role type */
export type LocationRole = 'admin' | 'manager' | 'viewer'

/** Location assignment for creating team member */
export interface LocationAssignment {
  location_id: string
  location_role: LocationRole
}

/** Form data for creating a team member directly */
export interface CreateTeamMemberFormData {
  email: string
  display_name?: string
  role: OrgRole
  location_assignments: LocationAssignment[]
}

/** Response from create team member edge function */
export interface CreateTeamMemberResponse {
  success: boolean
  user_id: string
  email: string
  is_new_user: boolean
  location_assignments_created: number
}
